import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CitaContext } from '../context/CitaContext';
import FormularioDatos from '../components/cliente/FormularioDatos';
import SelectorFechas from '../components/cliente/SelectorFechas';

const AgendarCita = () => {
  const { 
    servicioSeleccionado, 
    datosCliente,
    fechaSeleccionada,
    horaSeleccionada
  } = useContext(CitaContext);
  
  const navigate = useNavigate();
  const location = useLocation();
  const [paso, setPaso] = useState(1);
  const [alertaAgenda, setAlertaAgenda] = useState('');
  
  // Redireccionar si no hay servicio seleccionado
  React.useEffect(() => {
    if (!servicioSeleccionado) {
      navigate('/');
    }
  }, [servicioSeleccionado, navigate]);
  
  const validarDatosCliente = () => {
    return (
      datosCliente.nombre.trim() !== '' &&
      datosCliente.apellido.trim() !== '' &&
      datosCliente.email.trim() !== '' &&
      datosCliente.telefono.trim() !== '' &&
      datosCliente.cedula.trim() !== ''
    );
  };
  
  const validarFechaHora = () => {
    return fechaSeleccionada && horaSeleccionada;
  };

  React.useEffect(() => {
    const routeState = location.state;
    if (!routeState) return;

    const datosCompletos = (
      datosCliente.nombre.trim() !== '' &&
      datosCliente.apellido.trim() !== '' &&
      datosCliente.email.trim() !== '' &&
      datosCliente.telefono.trim() !== '' &&
      datosCliente.cedula.trim() !== ''
    );

    if (routeState.errorAgenda) {
      setAlertaAgenda(routeState.errorAgenda);
    }

    if (routeState.pasoInicial === 2 && datosCompletos) {
      setPaso(2);
      window.scrollTo(0, 0);
    }

    navigate(location.pathname, { replace: true, state: null });
  }, [
    location.state,
    location.pathname,
    navigate,
    datosCliente.nombre,
    datosCliente.apellido,
    datosCliente.email,
    datosCliente.telefono,
    datosCliente.cedula
  ]);
  
  const handleSiguiente = () => {
    if (paso === 1 && validarDatosCliente()) {
      setPaso(2);
      // Desplazar hacia arriba al cambiar de paso
      window.scrollTo(0, 0);
    } else if (paso === 2 && validarFechaHora()) {
      navigate('/pago');
    } else {
      alert('Por favor complete todos los campos requeridos');
    }
  };
  
  const handleAtras = () => {
    if (paso === 2) {
      setPaso(1);
      setAlertaAgenda('');
      // Desplazar hacia arriba al cambiar de paso
      window.scrollTo(0, 0);
    } else {
      navigate('/');
    }
  };
  
  if (!servicioSeleccionado) {
    return null;
  }
  
  return (
    <div className="booking-page">
      <header className="booking-topbar">
        <div className="booking-topbar-inner">
          <div>
            <h2 className="booking-topbar-title">Sistema de Citas Medicas</h2>
            <p className="booking-topbar-subtitle">Agendar una nueva cita</p>
          </div>
          <div className="booking-step-badge">
            <i className="fas fa-calendar-alt"></i>
            <span>Paso {paso} de 2</span>
          </div>
        </div>
      </header>

      <main className="booking-main">
        <div className="booking-panel">
          <div className="booking-steps">
            <div className={`booking-step ${paso === 1 ? 'is-active' : 'is-complete'}`}>
              <i className="fas fa-user-edit booking-step-icon"></i>
              Informacion personal
            </div>
            <div className={`booking-step ${paso === 2 ? 'is-active' : ''}`}>
              <i className="fas fa-calendar-day booking-step-icon"></i>
              Fecha y hora
            </div>
          </div>

          <div className="booking-service-banner">
            <div className="booking-service-icon">
              <i className="fas fa-stethoscope"></i>
            </div>

            <div className="booking-service-info">
              <h3 className="booking-service-title">
                {servicioSeleccionado.titulo}
              </h3>
              <p className="booking-service-description">
                {servicioSeleccionado.descripcion}
              </p>
            </div>

            <div className="booking-service-price">
              ${servicioSeleccionado.precio}
            </div>
          </div>

          <div className="booking-content">
            {alertaAgenda && (
              <div
                className="booking-alert-error"
                style={{
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px'
                }}
              >
                <span>
                  <i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                  {alertaAgenda}
                </span>
                <button
                  type="button"
                  onClick={() => setAlertaAgenda('')}
                  className="booking-btn booking-btn-secondary"
                  style={{ padding: '6px 10px', fontSize: '12px' }}
                >
                  Cerrar
                </button>
              </div>
            )}

            {paso === 1 && <FormularioDatos />}
            {paso === 2 && <SelectorFechas />}
          </div>

          <div className="booking-actions">
            <button
              onClick={handleAtras}
              className="booking-btn booking-btn-secondary"
              type="button"
            >
              <i className="fas fa-arrow-left"></i>
              {paso === 1 ? 'Volver a Servicios' : 'Volver a Datos personales'}
            </button>

            <button
              onClick={handleSiguiente}
              className="booking-btn booking-btn-primary"
              type="button"
            >
              {paso === 1 ? (
                <>
                  Siguiente paso <i className="fas fa-arrow-right"></i>
                </>
              ) : (
                <>
                  Continuar al Pago <i className="fas fa-credit-card"></i>
                </>
              )}
            </button>
          </div>
        </div>

        <div className="booking-note-card">
          <h4 className="booking-note-title">
            <i className="fas fa-info-circle"></i>
            {paso === 1 ? 'Informacion importante' : 'Acerca de su cita'}
          </h4>
          {paso === 1 ? (
            <ul className="booking-note-list">
              <li style={{ marginBottom: '8px' }}>Todos los campos son obligatorios para agendar su cita.</li>
              <li style={{ marginBottom: '8px' }}>Verifique que su numero de telefono y correo electronico sean correctos.</li>
              <li>Recibira un recordatorio de su cita 24 horas antes de la fecha programada.</li>
            </ul>
          ) : (
            <ul className="booking-note-list">
              <li style={{ marginBottom: '8px' }}>Seleccione la fecha y hora que mejor se adapte a su agenda.</li>
              <li style={{ marginBottom: '8px' }}>En caso de no poder asistir, por favor cancele su cita con 24 horas de anticipacion.</li>
              <li>Se recomienda llegar 15 minutos antes de su hora programada.</li>
            </ul>
          )}
        </div>

      </main>

      <footer className="booking-footer">
        <p>Copyright 2025 - BM Creatividad</p>
      </footer>
    </div>
  );
};

export default AgendarCita;